// FILE: src/pages/admin/student/AdminStudentActivityPage.jsx
// One account's audit log (WP-7; MTO 11.1.1, matrix 5.1): every sign-in and
// failed attempt, identity check, lesson session, break, support message
// and records download, with filters and server paging
// (GET /api/admin/audit-logs?userId=…).
import React from "react";
import AuditLogBrowser from "../../../components/admin/AuditLogBrowser";
import { useStudent } from "./AdminStudentLayout";

export default function AdminStudentActivityPage() {
  const { student } = useStudent();
  return <AuditLogBrowser userId={student._id} showEmail={false} showAccount={false} tableLabel="This account's activity" />;
}
